import * as React from 'react'
import Footer from '../Footer/Footer'
import Header from '../Header/Header'
import * as styles from './Layout.module.css'

export default function Layout({children}) {
    return (
        <div className={styles.layout}>
            <Header />
            {children}
            <Footer />
        </div>
    )
}
